<template>
	<div id="modal-inventory-products-edit-sources">
		<b-modal :id="modalName" title="Edit Sources" size="lg" scrollable hide-footer>
            <div>
                <b-table-simple hover small caption-top bordered responsive>
                    <b-thead head-variant="dark">
                        <b-tr>
                            <b-th>Type</b-th>
                            <b-th>Name</b-th>
                            <b-th class="text-center">ID</b-th>
                        </b-tr>
                    </b-thead>
                    <b-tbody>
                        <b-tr v-for="(source, index) in sources" :key="index">
                            <b-td>{{ source.sourceType }}</b-td>
                            <b-td>{{ source.sourceName }}</b-td>
                            <b-td class="text-center">
                                <quick-edit :id="'quick-edit-source-type-' + index" :value="source.sourceTrackedId"
                                    @close="textUpdateCallbackBlur(source.sourceTrackedRowId, source.sourceTrackedId, $event, source.sourceId)"
                                ></quick-edit>
                            </b-td>
                        </b-tr>
                    </b-tbody>
                </b-table-simple>
            </div>
        </b-modal>
    </div>
</template>

<script>
import QuickEdit from 'vue-quick-edit'
	export default {
		props: [
            'id'
        ],

        components: {
            QuickEdit
        },

		data() {
			return {
                modalName: 'modal-inventory-products-edit-sources',

                sources: []
			}
		},

		methods: {
            textUpdateCallbackBlur(rowId, oldVal, newVal, sourceId) {
				if (oldVal != newVal) {
					this.saveField(rowId, newVal, sourceId)
				}
			},

            saveField(rowId, newVal, sourceId) {
                let url = 'api/inventory/products/details/savesourceid'
                axios.post(url, {
                    itemId: this.id,
                    rowId: rowId,
                    newVal: newVal,
                    sourceId: sourceId
                })
                .then((res) => {
                    this.getSourceIds()
                }, () => {
                    this.has_error = true
                })
            },

            getSourceIds() {
                let url = 'api/inventory/products/details/getsourceids/' + this.id
                axios.get(url, {})
                .then((res) => {
                    this.sources = res.data.sources
                }, () => {
                    this.has_error = true
                })
            }
        },

        mounted() {
            this.getSourceIds()
        }
	}
</script>

<style lang="scss">
    #modal-inventory-products-edit-sources {
        .vue-quick-edit {
            .vue-quick-edit__input {
                width: 80px;
                padding: 5px;
                text-align: center;
            }
        }
    }
</style>
